// noinspection ES6CheckImport
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { ContentHeader, NoContentBox, BigModal } from 'components/basic'
import { AccessOrders, AccessOrderEvents, CustomTroubleshooting, AccessEditor, Subscriptions, AvailableServices, Tickets, CPEstatus, LinkStatus, MacAddressTable, LeaseInfo, IgmpSnoopStatus, MethodRunner } from 'projects/access-gui/components'
import http from 'API/http'

class Access extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null,
      methods: [],
      updated: Date.now()
    }
    this.interval = null
  }

  componentDidMount () {
    this.getMethods(this.props.match.params.accessid)
    this.getAccess(this.props.match.params.accessid)
  }

  componentWillUnmount () {
    this.stopAutoReload()
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.match.params.accessid === nextProps.match.params.accessid) return
    this.setState({access: null})
    this.getAccess(nextProps.match.params.accessid)
    this.getMethods(nextProps.match.params.accessid)
  }

  async getAccess (accessId) {
    var [err, res] = await http.get('2.4/accesses/' + accessId, {rich: true})
    if (err) return this.setState({'fourohfour': true})
    this.setState({access: res.data, updated: Date.now()})
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: `${res.data.streetName} ${res.data.streetNumber}`
    })
  }

  async getMethods (id) {
    var [err, res] = await http.get('troubleshoot/methods', {id: id})
    this.setState({methods: (err ? [] : res.data)})
  }

  autoReload () {
    this.interval = setTimeout(() => {
      this.getAccess(this.props.match.params.accessid)
      this.autoReload()
    }, 30000)
    this.forceUpdate()
  }

  stopAutoReload () {
    if (typeof this.interval !== 'undefined') {
      clearTimeout(this.interval)
      this.interval = null
    }
    this.forceUpdate()
  }

  render () {
    if (this.state.fourohfour) {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='exclamation-triangle' text='Access not found' />
        </div>
      )
    }
    if (!this.state.access) {
      return (
        <div className='content-wrapper flexbox-absolute-center'>
          <NoContentBox icon='circle-o-notch fa-spin' text='Loading Access' />
        </div>
      )
    }
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Access' subtitle={`${this.state.access.streetName} ${this.state.access.streetNumber}${this.state.access.streetLittera ? this.state.access.streetLittera : ''}`} buttons={[
          { tip: 'Access Overview', icon: 'fa-home', event: () => (window.location.hash = '/access') },
          { tip: 'Enable Autoreload', icon: 'fa-refresh', event: () => this.autoReload(), hidden: this.interval !== null },
          { tip: 'Disable Autoreload', icon: 'fa-stop-circle', event: () => this.stopAutoReload(), hidden: this.interval === null },
          { hidden: this.state.methods.length === 0, tip: 'Troubleshooting Methods', icon: 'fa-bars', dropdown: true, links: this.state.methods.map(method => {
                return {
                  text: <span><i className='fa fa-fw fa-cog' style={{'marginRight': '5px'}} /><b>{method.name}</b></span>,
                  event: () => this.setMethod(method)
                }
              }
            )
          }
        ]}/>
        {this.interval !== null &&
          <span className='label label-danger' style={{'top': '24px', 'position': 'absolute', 'right': '130px', 'fontSize': '11px'}}><i className='fa fa-fw fa-exclamation-triangle'/> Autoreload Enabled</span>
        }
        <hr />
        <div className='row'>
          <MethodRunner accessId={this.state.access.accessId} setMethod={setMethod => (this.setMethod = setMethod)} />
          <AccessEditor access={this.state.access} />
          <Subscriptions callback={() => this.getAccess(this.props.match.params.accessid)} subscriptions={this.state.access.subscriptions} services={this.state.access.services} accessId={this.state.access.accessId} updated={this.state.updated} />
        </div>
        <Tabs selectedTabClassName='flow-tab-active'>
          <TabList className='flow-tabs'>
            <Tab className='flow-tab'><i className='fa fa-home' /> Access</Tab>
            <Tab className='flow-tab'><i className='fa fa-shield' /> CPE Status</Tab>
            <Tab className='flow-tab'><i className='fa fa-server' /> Link Status</Tab>
            <Tab className='flow-tab'><i className='fa fa-globe' /> Client Info</Tab>
            <Tab className='flow-tab'><i className='fa fa-heartbeat' /> Maintrac Troubleshooting</Tab>
          </TabList>
          <TabPanel>
            <div className='row'>
              <AvailableServices callback={() => this.getAccess(this.props.match.params.accessid)} access={this.state.access} updated={this.state.updated} />
            </div>
            <div className='row'>
              <div className='col-md-6'>
                <div className='row'>
                  <AccessOrders callback={() => this.getAccess(this.props.match.params.accessid)} id={this.state.access.accessId} updated={this.state.updated} />
                  <AccessOrderEvents id={this.state.access.accessId} updated={this.state.updated} />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='row'>
                  <Tickets accessId={this.state.access.accessId} />
                </div>
              </div>
            </div>
          </TabPanel>
          <div>
            <TabPanel>
              <div className='row'>
                <CPEstatus id={this.state.access.accessId} updated={this.state.updated} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='row'>
                <LinkStatus id={this.state.access.accessId} updated={this.state.updated} />
              </div>
            </TabPanel>
            <TabPanel>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='row'>
                    <MacAddressTable id={this.state.access.accessId} updated={this.state.updated} />
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='row'>
                    <IgmpSnoopStatus id={this.state.access.accessId} updated={this.state.updated} />
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='row'>
                    <LeaseInfo id={this.state.access.accessId} updated={this.state.updated} />
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className='row'>
                <CustomTroubleshooting id={this.state.access.accessId} updated={this.state.updated} />
              </div>
            </TabPanel>
          </div>
        </Tabs>
      </div>
    )
  }
}
//eslint-disable-next-line
Access = connect(state => state.siteReducer)(Access)
export default Access



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/access/access.js